// Function to populate any ring size selectors with the value from the local storage
function fetchRingSizeFromLocalStorage() {
    const ringSize = localStorage.getItem('ringSize');
    return ringSize;
};

// Function to save the ring size to the local storage
function saveRingSizeToLocalStorage(ringSize) {
    localStorage.setItem('ringSize', ringSize);
};

function waitForElement(selector, maxRetries = 10, intervalMs = 1000) {
    return new Promise((resolve) => {
        let attempts = 0;

        const tryFind = () => {
            const element = document.querySelector(selector);

            if (element) {
                resolve(element);
                return;
            }

            attempts++;

            if (attempts >= maxRetries) {
                resolve(null);
                return;
            }

            setTimeout(tryFind, intervalMs);
        };

        tryFind();
    });
};

async function setRingSizeInDiamondBuilder(ringSize) {
    const selector = '.diamond-proxy-review-ring select:not([name="region"])';
    const diamondBuilderSelector = await waitForElement(selector, 10, 1000);

    if (!diamondBuilderSelector) {
        console.warn('Ring size selector not found after retries');

        return;
    }

    const options = diamondBuilderSelector.querySelectorAll('option');

    console.log(options);

    for (let option of options) {
        if (option.value === ringSize) {
            option.selected = true;
            break;
        }
    }

    diamondBuilderSelector.value = ringSize;
    diamondBuilderSelector.dispatchEvent(new Event('change', { bubbles: true }));
};

// Function to monitor URL changes for Complete+Ring
function waitForCompleteRingUrl() {
    return new Promise((resolve) => {
        const checkUrl = () => {
            if (window.location.href.includes('Complete+Ring')) {
                resolve();
                return;
            }
            setTimeout(checkUrl, 100);
        };
        checkUrl();
    });
}

document.addEventListener('DOMContentLoaded', async () => {
  const addDiamondLink = document.querySelector('#add-diamond-link');
  
  if (addDiamondLink) {
    addDiamondLink.addEventListener('click', (e) => {
      const ringSizeElement = document.querySelector('.dropdown-button-gsw__value');
      if (!ringSizeElement) {
        console.warn('Ring size dropdown element not found');
        return;
      }
      
      const selectedRingSize = ringSizeElement.textContent;
      const sanitisedRingSize = selectedRingSize.replace('1/2', '½').replace(' ', '');
      
      saveRingSizeToLocalStorage(sanitisedRingSize);
    });
  }
  
  // Listen for clicks on diamond-proxy-add-to-cart elements
  document.addEventListener('click', async (e) => {
    if (e.target.matches('.diamond-proxy-add-to-cart')) {

      const ringSize = fetchRingSizeFromLocalStorage();

      if (ringSize) {
        await setRingSizeInDiamondBuilder(ringSize);
      }
    }
  });
  
  const ringSize = fetchRingSizeFromLocalStorage();
  if (ringSize) {
      await setRingSizeInDiamondBuilder(ringSize);
  }
});